import React from "react";
import Layout from "./src/components/Layout";
import "./src/styles/import.scss";

export const wrapPageElement = ({ element }: any) => {
	return (
		<Layout>{element}</Layout>
	);
};
